export default __webpack_public_path__ + "232198f1ee20bb67838ea1468e61ff3d.png";